export default __webpack_public_path__ + "static/media/w_obesity.f5b1f410.svg";